export default __webpack_public_path__ + "images/createCase.da2bcdb2473eca107b55b1ab9a4db44a.svg";